var ValidUtils = {
    checkImei: function (value) {
        if(/^[A-Za-z0-9]{8,20}$/.test(value)){
            return {
                validateStatus: 'success',
                errorMsg: null,
            }
        }
        return {
            validateStatus: 'error',
            errorMsg: '请输入8至20位的IMEI号',
        }
    },
    checkImsi: function (value) {
        if(/^\d{15}$/.test(value)){
            return {
                validateStatus: 'success',
                errorMsg: null,
            }
        }
        return {
            validateStatus: 'error',
            errorMsg: '输入15位数字IMSI号',
        }
    },
    checkIccid: function (value) {
        if(/^[A-Za-z0-9]{10,30}$/.test(value)){
            return {
                validateStatus: 'success',
                errorMsg: null,
            }
        }
        return {
            validateStatus: 'error',
            errorMsg: '请输入10至30位的ICCID号',
        }
    },
    checkExtra: function (value) {
      if(/^[A-Za-z0-9]{10,150}$/.test(value)){
          return {
              validateStatus: 'success',
              errorMsg: null,
          }
      }
      return {
          validateStatus: 'error',
          errorMsg: '请输入10至150位的extra码',
      }
  },
    checkPhoneNumber: (value) => {
        if (/^1[34578]\d{9}$/.test(value)) {
            return {
                validateStatus: 'success',
                errorMsg: null
            }
        }
        return {
            validateStatus: 'error',
            errorMsg: '请输入正确的电话号码格式',
        }
    },
    hasSpecialChar: (rule, value, callback) => {
        // let regEn = /[`!@#$%^&*()_+<>?:"{},.\/;'[\]]/im
        let regCn = /[~！@#￥%……&*？[\]{}']/im
        if (regCn.test(value)) {
          callback('请不要使用特殊字符')
        }
        callback()
    }
}
// console.log(ValidUtils.checkImsi('123456789012345'))
export default ValidUtils;

